import React, {Component} from "react"
import {connect} from 'react-redux';
import Layout from "../../../components/Layout"
import "./index.scss"

import TableEdit from "../../../components/TableEdit"


import {
    schedule_get_rows_table,
    schedule_set_valores_lote,
    schedule_get_rows_table_count,
    schedule_set_valores_unitario
} from "../../../store/actions/schedule";

import {
    DataTableSkeleton, Grid, InlineNotification, ProgressIndicator, ProgressStep,
} from "carbon-components-react";


import data from "../../../data";
import moment from "moment";

const rows = [];

const headers = [
    {key: "timestamp", header: 'Date'},
    {key: "sku", header: 'SKU'},
    {key: "material_description", header: 'Description'},
    {key: "valor", header: 'Quantity'},
    {key: "marca", header: 'Brand'},
    {key: "channel", header: 'Channel'},
    {key: "hero", header: 'Hero'},
    {key: "abcd", header: 'ABCD'},
    {key: "plc_localsku", header: 'PLC Local'},
    {key: "category_sku", header: 'Category'},
    {key: "categoria_principal_sku", header: 'Major Category'},
]

class Edit extends Component {

    async componentDidMount() {
        await this.props.fetchData(0);
        await this.props.countRows();
    }

    async onSubmitForm(type, data) {
        if (type == "Individual") {
            this.props.saveUnitario(data);
        } else {
            this.props.saveLote(data);
        }
    }

    async onChangePagination(skip) {
        await this.props.fetchData(skip);
    }

    render() {
        const {data, isLoading, contador} = this.props;

        let desc = "Loading...";
        let contadorTotal = 0;
        let filtersD = JSON.parse(localStorage.getItem('formFilter'));
        let descDate = "";
        if (typeof contador.count !== undefined) {
            descDate = descDate.concat(' ', moment(filtersD.dateStart).format("MMM YYYY"), " - ", moment(filtersD.dateEnd).format("MMM YYYY"))
            contadorTotal = contador.count;
        }

        console.log(contador);
        let rows = data;
        rows =
            data?.length > 0
                ? data.map(execution => {
                    return {
                        ...execution,
                        id: execution._id,
                        timestamp: moment(execution.creationDate).format('DD MMM YYYY'),
                        sortDate: new Date(execution.creationDate),
                    };
                })
                : [];
        if (rows?.length > 0) rows.sort((a, b) => b.sortDate - a.sortDate);

        return (
            <Layout>
                <Grid class="painel" fullWidth>
                    <div className="header-text">
                        <h5>Intelligent Journey</h5>
                        <h3 style={{margin: '0 0 30px'}}>Planning review</h3>
                    </div>
                    <div className="some-container">
                        <ProgressIndicator currentIndex={1}>
                            <ProgressStep
                                label="Select"
                                description="Step 1: Getting started with Carbon Design System"
                            />
                            <ProgressStep
                                current
                                label="Edit"
                                description="Step 5: Getting started with Carbon Design System"
                            />
                        </ProgressIndicator>
                    </div>

                    {isLoading ? (
                            <div className="bx--col-padding  p-2-rem">
                                <DataTableSkeleton/>
                            </div>
                        ) :
                        <div className="bx--col-padding p-2-rem">
                            {rows.length == 0 ? (
                                <div>
                                    <InlineNotification
                                        lowContrast={true}
                                        kind="info"
                                        iconDescription="Info"
                                        subtitle={<span>No data found</span>}
                                        title=""
                                    />
                                </div>) :("")}

                            <TableEdit rows={rows}
                                       headers={headers}
                                       isLoading={isLoading}
                                       contadorTotal={contadorTotal}
                                       descDate={descDate}
                                       onChangePagination={(e) => this.onChangePagination(e)}
                                       onSubmitForm={(type, data) => this.onSubmitForm(type, data)}
                            />
                        </div>
                    }

                </Grid>
            </Layout>
        )
    }
}

const mapStateToProps = ({schedule}) => schedule;

const mapDispatchToProps = dispatch => ({
    saveLote: (valor) => dispatch(schedule_set_valores_lote(valor)),
    saveUnitario: (valor) => dispatch(schedule_set_valores_unitario(valor)),
    fetchData: (skip) => dispatch(schedule_get_rows_table(skip)),
    countRows: () => dispatch(schedule_get_rows_table_count()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Edit);
